import { mergeQueryParams } from 'modules/taboola-common-frontend-modules/query-params';
import { FORM_MODES, PERFORMANCE_STATUS_TO_CREATIVE_TYPE_MAP } from '../../../config';
import { generateCreativeSchedulerPath } from '../../../services/utils';
import { cleanCreativesEditingResources } from '../../creative-editor';
import { INITIAL_CREATIVE_TYPE } from '../../creative-editor/hooks/useInitialCreativeType';
import { isEditCreativeAllowed } from '../config/predicates';

export const scheduleCreative = ({ data, context }) => {
    if (!isEditCreativeAllowed(data)) {
        return;
    }

    const { accountName: accountId, campaignId, id: creativeId, dimension } = data;
    const { navigate, dispatch } = context;
    const creativeType = PERFORMANCE_STATUS_TO_CREATIVE_TYPE_MAP[data.performanceStatus];

    dispatch(() => {
        const scheduleCreativePath = generateCreativeSchedulerPath({
            accountId,
            campaignId,
            creativeId,
            mode: FORM_MODES.EDIT,
            dimension,
        });

        const pathWithCreativeType = `${scheduleCreativePath}${mergeQueryParams('', {
            [INITIAL_CREATIVE_TYPE]: creativeType,
        })}`;

        dispatch(cleanCreativesEditingResources());

        navigate(pathWithCreativeType);
    });
};
